import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-1);

    @supports not (row-gap: 0) {
        & > span {
            margin-bottom: var(--spacing-1);
        }
    }
`;
